import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import { logout } from "../../actions/Authentication";

class SideMenu extends Component {
  onLogoutClick() {
    this.props.logout();
  }

  render() {
    const { menuActiveComponent } = this.props;

    return (
      <div>
        <ul className="nav flex-column manu-bar">
          <div className="item logo-img">
            <Link to={"/"}>
              <img src="/resources/img/Rectangle.svg" alt="Admin" />
            </Link>
          </div>
          <div className="item user-name">
            <p>Administrator</p>
            <label
              onClick={this.onLogoutClick.bind(this)}
              style={{ paddingTop: 8, cursor: "Pointer" }}
            >
              Logout
            </label>
          </div>
          <div className="divider" />
          <li className="item nav-item">
            <Link
              to={"/"}
              className={`nav-link ${
                menuActiveComponent === "dashboard" ? "active" : ""
              }`}
            >
              Dashboard
            </Link>
          </li>
          <li className="item nav-item">
            <Link
              to={"/sales-report"}
              className={`nav-link ${
                menuActiveComponent === "sales-report" ? "active" : ""
              }`}
            >
              Sales Report
            </Link>
          </li>
          <div className="divider" />
          <li className="item nav-item">
            <Link
              to={"/orders"}
              className={`nav-link ${
                menuActiveComponent === "orders" ? "active" : ""
              }`}
            >
              Orders
            </Link>
          </li>
          {/* <li className="item nav-item">
            <Link to={'/invetory'} className={`nav-link ${menuActiveComponent === 'invetory' ? 'active' : ''}`}>Invetory</Link>
          </li> */}
          <li className="item nav-item">
            <Link
              to={"/products"}
              className={`nav-link ${
                menuActiveComponent === "products" ? "active" : ""
              }`}
            >
              Products
            </Link>
          </li>
          <li className="item nav-item">
            <Link
              to={"/blogs"}
              className={`nav-link ${
                menuActiveComponent === "blogs" ? "active" : ""
              }`}
            >
              Blogs
            </Link>
          </li>
          <li className="item nav-item">
            <Link
              to={"/promotions"}
              className={`nav-link ${
                menuActiveComponent === "promotions" ? "active" : ""
              }`}
            >
              Promotions
            </Link>
          </li>
          <li className="item nav-item">
            <Link
              to={"/highlight-products"}
              className={`nav-link ${
                menuActiveComponent === "highlight-products" ? "active" : ""
              }`}
            >
              Highlight Products
            </Link>
          </li>
          <li className="item nav-item">
            <Link
              to={"/slideshow"}
              className={`nav-link ${
                menuActiveComponent === "slideshow" ? "active" : ""
              }`}
            >
              Slideshow
            </Link>
          </li>
          <li className="item nav-item">
            <Link
              to={"/members"}
              className={`nav-link ${
                menuActiveComponent === "members" ? "active" : ""
              }`}
            >
              Members
            </Link>
          </li>
          <li className="item nav-item">
            <Link
              to={"/first-section-content"}
              className={`nav-link ${
                menuActiveComponent === "first-section-content" ? "active" : ""
              }`}
            >
              First Section Content
            </Link>
          </li>
          <div className="divider" />
          <li className="item nav-item">
            <Link
              to={"/settings"}
              className={`nav-link ${
                menuActiveComponent === "settings" ? "active" : ""
              }`}
            >
              Settings
            </Link>
          </li>
        </ul>
      </div>
    );
  }
}

export default connect(
  null,
  { logout }
)(SideMenu);



// WEBPACK FOOTER //
// ./src/views/main/SideMenu.js